import React from 'react';
import { Link } from 'react-router-dom';

const About = ({
  subtitle,
  title,
  description,
  image,
  buttonLabel,
  buttonLink,
  reverse = false,
  showImage = true,
  showButton = true,
}) => {
  return (
    <section className="py-10 sm:py-14 md:py-18 px-4 sm:px-6 md:px-10 lg:px-12 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div
          className={`flex flex-col-reverse ${
            reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'
          } items-center gap-8 sm:gap-10 md:gap-16 lg:gap-20`}
        >
          {/* Text Section */}
          <div className="w-full lg:w-1/2 text-left px-2 sm:px-0">
            {subtitle && (
              <p className="text-[#1a81ba] font-semibold mb-2 sm:mb-3 md:mb-4 uppercase tracking-wide text-xs sm:text-sm md:text-base">
                {subtitle}
              </p>
            )}

            {title && (
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-semibold text-[#03C04a] leading-snug md:leading-tight mb-3 sm:mb-5">
                {title}
              </h2>
            )}

            {description && (
            <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-2xl text-justify">
                {description}
              </p>
            )}

            {showButton && buttonLabel && buttonLink && (
              <div className="flex justify-start">
                <Link
                  to={buttonLink}
                  className="inline-block bg-[#1a81ba] text-white py-2 sm:py-2.5 md:py-3 px-6 sm:px-8 md:px-10 rounded-lg font-semibold text-sm sm:text-base md:text-lg shadow-md hover:bg-[#166da0] transition-all transform hover:-translate-y-0.5"
                >
                  {buttonLabel}
                </Link>
              </div>
            )}
          </div>

          {/* Image Section */}
          {showImage && image && (
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={image}
                alt={title || 'About section'}
                className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-52 sm:h-64 md:h-80 lg:h-96 object-cover rounded-2xl shadow-xl border border-gray-200 hover:shadow-2xl transition-transform duration-700 hover:scale-[1.03]"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default About;
